import React, { useState } from 'react'

interface IconChipProps {
    label: string
    style: string
    icon: string
    iconWhite: string
    section: string;
    onClick: (section: string) => void;
}

const IconChip: React.FC<IconChipProps> = ({
    label,
    style,
    icon,
    iconWhite,
    section,
    onClick
}) => {
    const [isHovered, setIsHovered] = useState(false)

    const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        onClick(section);
    };


    return (
        <span
            onClick={handleOnClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={`cursor-pointer ${style} ${isHovered ? 'hover' : ''}`}
        >
            {' '}
            <a href='#' onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                e.preventDefault();
            }}>
                {label}
            </a>
            <img src={isHovered ? iconWhite : icon} alt="Tag Icon" />
        </span>
    )
}

export default IconChip
